import React from 'react';
import styles from './ConfirmationModal.module.scss';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    <h3>{title}</h3>
                    <button onClick={onClose} className={styles.closeButton}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className={styles.modalBody}>
                    <p>{message}</p>
                </div>
                <div className={styles.modalFooter}>
                    <button onClick={onClose} className={styles.cancelBtn}>Cancel</button>
                    <button onClick={onConfirm} className={styles.confirmBtn}>Yes, Confirm</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;